import React, { Component } from "react";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import Api from "../../Api";

class ICCLRForm extends Component {
  constructor() {
    super();
    this.state = {
      defDossier: null,
      voornaam: "",
      tussenvoegsels: "",
      achternaam: "",
      geslacht: null,
      mobil: "",
      email: "",
      postcode: "",
      straat: "",
      huis: "",
      woonplaats: "",
      contributie: null,
      privacyverklaring: null,
      aanmelding: null,
    };
    this.submitForm = this.submitForm.bind(this);
  }

  async submitForm(e) {
    e.preventDefault();
    const personen = {
      defDossier: 3214,
      64082: this.state.voornaam,
      64079: this.state.achternaam,
      64080: this.state.geslacht,
      64081: this.state.mobil,
      64083: this.state.tussenvoegsels,
      64084: this.state.email,
      64085: this.state.postcode,
      64086: this.state.huis,
      64087: this.state.straat,
      64088: this.state.woonplaats,
    };
    const data = await Api.dossiers.create(personen);

    const aanmeldingen = {
      defDossier: 3213,
      64018: this.state.voornaam,
      64019: this.state.achternaam,
      64020: this.state.geslacht,
      64021: this.state.mobil,
      64023: this.state.tussenvoegsels,
      64024: this.state.email,
      64025: this.state.postcode,
      64026: this.state.huis,
      64027: this.state.straat,
      64028: this.state.woonplaats,
      64029: this.state.contributie,
      64030: this.state.privacyverklaring,
      64031: this.state.aanmelding,
    };
    const dossier = await Api.dossiers.create(aanmeldingen);
    await Api.dossiers.update(
      dossier.id,
      {
        64059: [data.id],
      },
      "displayPosition=13544"
    );
    alert("Success!");
    this.setState({
      defDossier: null,
      voornaam: "",
      tussenvoegsels: "",
      achternaam: "",
      geslacht: null,
      mobil: "",
      email: "",
      postcode: "",
      straat: "",
      huis: "",
      woonplaats: "",
      contributie: null,
      privacyverklaring: null,
      aanmelding: null,
    });
  }

  TextAreaField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start w-full">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>
          <textarea
            rows={3}
            {...register(name, rules)}
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
            className="block p-2 w-full text-sm text-gray-900  rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
          ></textarea>

          {errors[name] && (
            <span className="text-red-500 text-sm">This field is required</span>
          )}
        </div>
      </>
    );
  }

  CheckBoxField(label, name, options, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;
    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules?.required && <span className="text-red-500">*</span>} {label}
          </label>
          {options.map((opt, idx) => (
            <div className="flex gap-2" key={idx}>
              <input
                type="checkbox"
                {...register(name, rules)}
                value={opt.value}
              />
              <label className="float-left text-left">{opt.label}</label>
            </div>
          ))}

          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }

  DateField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>

          <input
            {...register(name, rules)}
            type="date"
            className="h-10 border mt-1 rounded px-2 w-full bg-gray-50"
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
          />
          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }

  PhoneField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>
          <PhoneInput
            placeholder="Enter phone number"
            {...register(name, rules)}
            value={this.state[name]}
            onChange={(value) => this.setState({ [name]: value })}
            className="h-10 border mt-1 rounded px-2 w-full bg-gray-50"
          />

          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }

  TextField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>
          <input
            {...register(name, rules)}
            type="text"
            className="h-10 border mt-1 rounded px-2 w-full bg-gray-50"
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
          />
          {errors[name] && (
            <span className="text-red-500 text-sm">This field is required</span>
          )}
        </div>
      </>
    );
  }

  EmailField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>
          <input
            {...register(name, rules)}
            type="email"
            className="h-10 border mt-1 rounded px-2 w-full bg-gray-50"
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
          />
          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }

  render() {
    return (
      <>
        <div className="p-5 d-flex flex-column gap-5">
          <div className=" d-flex justify-content-center w-full">
            <img src="https://i.imgur.com/NWK49sP.png" alt="logo" />
          </div>

          <h1 className="text-3xl font-bold spt-2">BFC Inschrijfformulier</h1>
          <div
            className=" bg-white rounded-lg shadow-md border border-gray-200 p-6"
            onSubmit={this.submitForm}
          >
            <form className="grid grid-cols-3 gap-3">
              {this.TextField("Volledige naam", "volledige_naam", {
                required: true,
              })}
              {this.TextField("Leeftijd", "leeftijd", {
                required: true,
              })}
              {this.DateField("Geboortedatum", "geboortedatum", {
                required: "This Field required",
              })}
              {this.TextField("Stad van verblijf", "stad_van_verblijf", {
                required: true,
              })}
              {this.EmailField("E-mailadres", "email", {
                required: { value: true, message: "Email is required" },
              })}

              <div className="">
                <label
                  for="Identificatienummer"
                  className="form-label fw-bold float-start"
                >
                  <span className="text-red-500">*</span> Identificatienummer
                </label>
                <input
                  type="number"
                  className="h-10 border mt-1 rounded px-2 w-full bg-gray-50"
                  id="Identificatienummer"
                  value={this.state.achternaam}
                  onChange={(e) => {
                    this.setState({ achternaam: e.target.value });
                  }}
                />
              </div>
              {this.PhoneField("Telefoonnummer", "phone", {
                required: "This Field Is Required",
              })}
              {this.TextField(
                "Naam van het team waar je momenteel in zit",
                "naam_van",
                {
                  required: true,
                }
              )}
              {this.TextField("T-shirt maat", "t_shirt", {
                required: true,
              })}
              {this.TextField(
                "Naam in de netwerken (Facebook of Instagram)",
                "netwerken",
                {
                  required: true,
                }
              )}
            </form>
          </div>

          <h2 className="text-3xl font-bold spt-2">WERK-/STUDIEGEGEVENS</h2>
          <div
            className=" bg-white rounded-lg shadow-md border border-gray-200 p-6"
            onSubmit={this.submitForm}
          >
            <form className="grid grid-cols-2 gap-4">
              {this.TextField("NAAM SCHOOL/BAAN", "naam_school", {
                required: true,
              })}

              {this.TextAreaField("SCHOOL-/WERKSCHEMA'S", "schools", {
                required: "This Field is Required",
              })}
            </form>
          </div>

          <h2 className="text-3xl font-bold spt-2">ERVARING IN</h2>
          <div
            className=" bg-white rounded-lg shadow-md border border-gray-200 p-6"
            onSubmit={this.submitForm}
          >
            <form className="flex justify-between items-start">
              {this.CheckBoxField(
                `VAARDIGHEDEN ALS BASIS:`,
                "huisvesting",
                [
                  {
                    value: 34670,
                    label: "Balcontrole",
                  },
                  {
                    value: 34668,
                    label: "Pass",
                  },
                  {
                    value: 34667,
                    label: "Dribbelen",
                  },
                  {
                    value: 34666,
                    label: "Schieten",
                  },
                  {
                    value: 34666,
                    label: "Snelheid",
                  },
                  {
                    value: 34666,
                    label: "Kracht",
                  },
                  {
                    value: 34666,
                    label: "Tactische intelligentie",
                  },
                  {
                    value: 34666,
                    label: "Positionering",
                  },
                  {
                    value: 34666,
                    label: "Visie op het spel",
                  },
                ],
                {
                  required: {
                    value: true,
                    message: "field is required",
                  },
                }
              )}
              {this.CheckBoxField(
                `SPELVAARDIGHEDEN:`,
                "huisvesting",
                [
                  {
                    value: 34670,
                    label: "Vertrouwen",
                  },
                  {
                    value: 34668,
                    label: "Veerkracht",
                  },
                  {
                    value: 34667,
                    label: "Discipline",
                  },
                  {
                    value: 34666,
                    label: "Passie voor het spel",
                  },
                  {
                    value: 34666,
                    label: "Aanpassingsvermogen",
                  },
                  {
                    value: 34666,
                    label: "Communicatie",
                  },
                  {
                    value: 34666,
                    label: "Leiderschap",
                  },
                ],
                {
                  required: {
                    value: true,
                    message: "field is required",
                  },
                }
              )}
              {this.CheckBoxField(
                `POSITIE BINNEN HET TEAM:`,
                "huisvesting",
                [
                  {
                    value: 60807,
                    label: "Doelman (keeper)",
                  },
                  {
                    value: 34668,
                    label: "Verdediger",
                  },
                  {
                    value: 34667,
                    label: "Middenvelders (Flyers)",
                  },
                  {
                    value: 34666,
                    label: "Voorwaarts (Aanvallers)",
                  },
                ],
                {
                  required: {
                    value: true,
                    message: "field is required",
                  },
                }
              )}
            </form>

            <form className="grid grid-cols-2 gap-8 mt-5">
              {this.TextAreaField(
                "TEAMS DIE HEBBEN DEELGENOMEN VAN 2021 TOT 2024",
                "schools",
                {
                  required: "This Field is Required",
                }
              )}
              {this.TextAreaField(
                "WAAROM JE DEEL WILT UITMAKEN VAN TEAM BFC 2024",
                "schools",
                {
                  required: "This Field is Required",
                }
              )}
              <div className="">
                <label
                  for="achternaam"
                  className="form-label fw-bold float-start"
                >
                 <span className="text-red-500">*</span>  FOTO KAARTGROOT (huidig)
                </label>
                <input
                  type="file"
                  class="block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-gray-200 file:text-black hover:file:bg-gray-400"
                />
              </div>
            </form>
          </div>

          <div
            className=" bg-white rounded-lg shadow-md border border-gray-200 p-6"
            onSubmit={this.submitForm}
          >
            <div className="flex flex-col justify-center items-center">
              <label className="form-label fw-bold float-start text-xl">
                Bedankt voor het vullen van het aanmeldformulier.
              </label>
              <label
                for="achternaam"
                className="form-label fw-bold float-start text-xl"
              >
                Ter bevestiging van uw aanmelding
              </label>
              <button
                type="submit"
                className="mt-3 flex justify-center bg-gray-300 w-32 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded items-center"
              >
                Verstuur
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ICCLRForm;
